import { API_BASE_URL } from "../urls.api";

export const getAlarmsByRoomIdUrl = (roomId: string) => `${API_BASE_URL}/alarms/${roomId}`;

export const getAlarmsByRoomIdAndRangeUrl = (roomId: string, from: number, to: number) =>
  `${API_BASE_URL}/alarms/${roomId}/range?from=${from}&to=${to}`;

export const getAlarmListByParamsUrl = (params?: {
  from?: number;
  to?: number;
  roomId?: string;
  showAll?: boolean;
  ownerId?: string;
  page?: number;
  limit?: number;
  type?: string;
}) => {
  const baseUrl = `${API_BASE_URL}/alarms/paginated`;

  if (!params) return baseUrl;

  const searchParams = new URLSearchParams();

  if (params.from !== undefined) searchParams.append("from", params.from.toString());
  if (params.to !== undefined) searchParams.append("to", params.to.toString());
  if (params.roomId) searchParams.append("roomId", params.roomId);
  if (params.showAll !== undefined) searchParams.append("showAll", params.showAll.toString());
  if (params.ownerId) searchParams.append("ownerId", params.ownerId);
  if (params.page !== undefined) searchParams.append("page", params.page.toString());
  if (params.limit !== undefined) searchParams.append("limit", params.limit.toString());
  if (params.type) searchParams.append("type", params.type);

  const queryString = searchParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const getAlarmStatisticsByParamsUrl = (params?: {
  roomId?: string;
  ownerId?: string;
}) => {
  const baseUrl = `${API_BASE_URL}/alarms/statistics`;

  if (!params) return baseUrl;

  const searchParams = new URLSearchParams();

  if (params.roomId) searchParams.append("roomId", params.roomId);
  if (params.ownerId) searchParams.append("ownerId", params.ownerId);

  const queryString = searchParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
